import { openPopupWindow } from './window';

export const openNewOauthPopup = (url: string, name: string, receiver: (event: MessageEvent<unknown>) => void) => {
  openPopupWindow(url, name, receiver);
};
